export default `
    <div id="#= data.id || "" #" class="#: data.classes || "" # #=data.bsc||""#" style="#=data.style || ""#">
        <div class="z-widget-header">#= data.title || "Default Title" #</div>
        <div class="widget-icons">
            <span  id="#= data.id #_PrintButton" class="print-widget-icon #= data.iconClasses # # if (data.disabled) { # disabled # } #"></span>
        </div>
        <span class="collapse k-icon k-i-arrow-chevron-up"></span>
        <div class="z-widget-contents">
                #= data.contents ? data.contents : "" #
        </div>
    </div>
`;
